import React from 'react';
import { Button } from './ui/button';

const ShimmerButton = ({ 
  children, 
  className = '', 
  variant = 'default',
  ...props 
}) => {
  const baseClasses = `
    relative 
    overflow-hidden 
    font-montserrat
    before:absolute 
    before:inset-0 
    before:bg-gradient-to-r 
    before:from-transparent 
    before:via-white/20 
    before:to-transparent 
    before:translate-x-[-100%] 
    before:animate-shimmer 
    before:duration-1000
    hover:before:translate-x-[100%]
    transition-all
    duration-300
    hover:scale-105
    hover:shadow-lg
  `;

  return (
    <Button
      className={`${baseClasses} ${className}`}
      variant={variant}
      {...props}
    >
      <span className="relative z-10">{children}</span>
    </Button>
  );
};

export default ShimmerButton;